import { Injectable } from '@angular/core';
import { LambdaClient, InvokeCommand } from '@aws-sdk/client-lambda';
import { environment } from 'environments/environment';
import { AuthSessionCacheService } from './auth-session-cache.service';

@Injectable({
  providedIn: 'root',
})
export class ClientLambdaService {
  constructor(private authSessionCacheService: AuthSessionCacheService) {}

  // shared lambda code to invoke lambda ( Note to make it reuseable instead of code copy paste)
  /**
   *
   * @param functionName name of lambda/function in backend to invoke
   * @param event  an object send as input to lambda
   * @returns response from lambda
   */
  async invokeLambda(functionName: string, event: any, invocationType = null, defaultTimeOut = 120000): Promise<any> {
    const credentials = await this.authSessionCacheService.getCredentials();
    // add region and credentials for access permission to execute lambda
    const client = new LambdaClient({
      credentials,
      region: environment.region,
      requestHandler: {
        metadata: { timeout: defaultTimeOut }, // default timeout
      },
    });
    // Information which will be send as parameters like event.json in lambda
    const params = invocationType
      ? {
          FunctionName: `${functionName}-${environment.name}`,
          Payload: JSON.stringify(event),
          InvocationType: invocationType,
        }
      : {
          FunctionName: `${functionName}-${environment.name}`,
          Payload: JSON.stringify(event),
        };
    // Invoking lambda
    try {
      const command = new InvokeCommand(params);
      const result = await client.send(command);
      return result;
    } catch (e) {
      return null;
    }
  }

  /**
   * Invoke a Lambda function using the exact function name provided (no env suffix appended).
   * Use this for external Lambdas that already include the environment in their name.
   */
  async invokeLambdaRaw(
    functionName: string,
    event: any,
    invocationType = null,
    defaultTimeOut = 120000
  ): Promise<any> {
    const credentials = await this.authSessionCacheService.getCredentials();
    const client = new LambdaClient({
      credentials,
      region: environment.region,
      requestHandler: {
        metadata: { timeout: defaultTimeOut },
      },
    });
    const params = invocationType
      ? {
          FunctionName: functionName,
          Payload: JSON.stringify(event),
          InvocationType: invocationType,
        }
      : {
          FunctionName: functionName,
          Payload: JSON.stringify(event),
        };
    try {
      const command = new InvokeCommand(params);
      const result = await client.send(command);
      return result;
    } catch (e) {
      return null;
    }
  }
}
